var _Corbado_corbadoAppState, _Corbado_componentInstances, _Corbado_telemetryConfig, _Corbado_mountComponent, _Corbado_unmountComponent, _Corbado_getCorbadoAppState;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { CorbadoAuth, Login, PasskeyList, SignUp, User } from '@corbado/react';
import { CorbadoAppState } from '../models/CorbadoAppState';
import { mountComponent, unmountComponent } from '../ui/mountComponent';
export class Corbado {
    constructor() {
        _Corbado_corbadoAppState.set(this, void 0);
        _Corbado_componentInstances.set(this, new Map());
        _Corbado_telemetryConfig.set(this, void 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _Corbado_mountComponent.set(this, (element, Component, componentOptions) => {
            if (!__classPrivateFieldGet(this, _Corbado_corbadoAppState, "f")) {
                throw new Error('Please call load() before mounting components');
            }
            __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
            const root = mountComponent(__classPrivateFieldGet(this, _Corbado_corbadoAppState, "f"), element, Component, componentOptions, __classPrivateFieldGet(this, _Corbado_telemetryConfig, "f"));
            __classPrivateFieldGet(this, _Corbado_componentInstances, "f").set(element, root);
        });
        _Corbado_unmountComponent.set(this, (element) => {
            if (!__classPrivateFieldGet(this, _Corbado_corbadoAppState, "f")) {
                throw new Error('Please call load() before unmounting components');
            }
            const existingRoot = __classPrivateFieldGet(this, _Corbado_componentInstances, "f").get(element);
            if (existingRoot) {
                unmountComponent(existingRoot);
            }
        });
        _Corbado_getCorbadoAppState.set(this, () => {
            if (!__classPrivateFieldGet(this, _Corbado_corbadoAppState, "f")) {
                throw new Error('Please call load() before using this library');
            }
            return __classPrivateFieldGet(this, _Corbado_corbadoAppState, "f");
        });
    }
    get user() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).user;
    }
    get sessionToken() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).sessionToken;
    }
    get sessionTokenChanges() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).sessionTokenChanges;
    }
    get userChanges() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).userChanges;
    }
    get isAuthenticated() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).isAuthenticated;
    }
    get authStateChanges() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).authStateChanges;
    }
    async load(options, telemetry) {
        const corbadoAppState = new CorbadoAppState(options);
        await corbadoAppState.init();
        __classPrivateFieldSet(this, _Corbado_corbadoAppState, corbadoAppState, "f");
        __classPrivateFieldSet(this, _Corbado_telemetryConfig, telemetry, "f");
    }
    mountAuthUI(element, options) {
        __classPrivateFieldGet(this, _Corbado_mountComponent, "f").call(this, element, CorbadoAuth, options);
    }
    unmountAuthUI(element) {
        __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
    }
    mountSignUpUI(element, options) {
        __classPrivateFieldGet(this, _Corbado_mountComponent, "f").call(this, element, SignUp, options);
    }
    unmountSignUpUI(element) {
        __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
    }
    mountLoginUI(element, options) {
        __classPrivateFieldGet(this, _Corbado_mountComponent, "f").call(this, element, Login, options);
    }
    unmountLoginUI(element) {
        __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
    }
    mountPasskeyListUI(element) {
        __classPrivateFieldGet(this, _Corbado_mountComponent, "f").call(this, element, PasskeyList, {});
    }
    unmountPasskeyListUI(element) {
        __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
    }
    mountUserUI(element) {
        __classPrivateFieldGet(this, _Corbado_mountComponent, "f").call(this, element, User, {});
    }
    unmountUserUI(element) {
        __classPrivateFieldGet(this, _Corbado_unmountComponent, "f").call(this, element);
    }
    logout() {
        if (!__classPrivateFieldGet(this, _Corbado_corbadoAppState, "f")) {
            throw new Error('Please call load() before logging out');
        }
        return __classPrivateFieldGet(this, _Corbado_corbadoAppState, "f").logout();
    }
    getPasskeys(abortController) {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).corbadoApp.sessionService.passkeyList(abortController !== null && abortController !== void 0 ? abortController : new AbortController());
    }
    appendPasskey() {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).corbadoApp.sessionService.appendPasskey();
    }
    deletePasskey(id) {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).corbadoApp.sessionService.passkeyDelete(id);
    }
    getFullUser(abortController) {
        return __classPrivateFieldGet(this, _Corbado_getCorbadoAppState, "f").call(this).corbadoApp.sessionService.getFullUser(abortController !== null && abortController !== void 0 ? abortController : new AbortController());
    }
}
_Corbado_corbadoAppState = new WeakMap(), _Corbado_componentInstances = new WeakMap(), _Corbado_telemetryConfig = new WeakMap(), _Corbado_mountComponent = new WeakMap(), _Corbado_unmountComponent = new WeakMap(), _Corbado_getCorbadoAppState = new WeakMap();
